import React from 'react';
import i18next from 'i18next';

import { MODALS } from '~redux/Modal/constants';
import { arrayHasLength, getUniqueListBy } from '~utils/array';

import ErrorModal from '../ErrorModal';

import styles from './styles.module.scss';
import UnavailableItem from './components/UnavailableItem';
import RemoveItemsButton from './components/RemoveItemsButton';
import { BUTTONS } from './constants';
import { useFilteredCartItems } from './useFilteredCartItems';

const UnavailableProducts = () => {
  const { items, modifiers } = useFilteredCartItems();

  const areUnavailableProducts = arrayHasLength(items) || arrayHasLength(modifiers);

  return (
    <ErrorModal
      modalName={MODALS.UNAVAILABLE_PRODUCTS}
      showModal={areUnavailableProducts}
      buttons={BUTTONS}
      buttonComponent={RemoveItemsButton}>
      <div className="column middle center text-center">
        <div className="title-large m-bottom-3">{i18next.t('UnavailableProducts:error')}</div>
        <div className={`m-bottom-5 ${styles.itemsContainer}`}>
          <div className="m-bottom-5">{i18next.t('UnavailableProducts:unavailable')}</div>
          {items?.map((item) => (
            <UnavailableItem key={item.hash} item={item} />
          ))}
          {getUniqueListBy(modifiers?.filter(Boolean), 'id')?.map((item) => (
            <UnavailableItem key={item.name} item={item} isModifier />
          ))}
        </div>
      </div>
    </ErrorModal>
  );
};

export default UnavailableProducts;
